/* Figma Nav Bar _Left: 40×40, значок 24 #212529 (content-primary); статья (Button Group 1) — круг 44 на --ground,
   значок 72% (content-sub-primary), как соседняя «к источнику» */
.back { flex: none; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;
  border-radius: 50%; color: var(--content-primary); }
.round { width: 44px; height: 44px; background: var(--ground); color: var(--content-sub-primary); }
